export default {"src":"/frontend-static/_next/static/media/hoodie.2b2e3af0.svg","height":210,"width":203,"blurWidth":0,"blurHeight":0};